const offerLink = require('./offerLink')
const slugifyUrl = require('../slug/slugifyUrl')

module.exports = (offer) => slugifyUrl(offerLink(offer, false))